<template>
  <div class="mark-overll" v-if="markeData">
    <!-- 罗茨泵电机非驱动端水平 -->
    <div
      id="marke-lcbdj-fqd"
      class="tire"
      v-if="markeData.lcbdj_fqd.length"
      style="top:-0.1rem;left:-1rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Roots pump motor non-drive end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lcbdj, lcbdj_i) in markeData.lcbdj_fqd"
            :key="lcbdj_i"
            class="detail-cont"
          >
            <label>{{ lcbdj.label }}:</label>
            <div :style="{ color: statusColor[lcbdj.status].color }">
              {{ lcbdj.value }}
            </div>
            <div :style="{ color: statusColor[lcbdj.status].color }">
              <img
                :src="statusColor[lcbdj.status].icon"
                :class="[
                  lcbdj.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 罗茨泵电机驱动端水平 -->
    <div
      id="marke-lcbdj-qd"
      class="tire"
      v-if="markeData.lcbdj_qd.length"
      style="top:0.5rem;left:-0.6rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Roots pump motor drive end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lcbdj, lcbdj_i) in markeData.lcbdj_qd"
            :key="lcbdj_i"
            class="detail-cont"
          >
            <label>{{ lcbdj.label }}:</label>
            <div :style="{ color: statusColor[lcbdj.status].color }">
              {{ lcbdj.value }}
            </div>
            <div :style="{ color: statusColor[lcbdj.status].color }">
              <img
                :src="statusColor[lcbdj.status].icon"
                :class="[
                  lcbdj.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 罗茨泵驱动端水平 -->
    <div
      id="marke-lcb-qd"
      class="tire"
      v-if="markeData.lcb_qd.length"
      style="top:0.4rem;left:0.05rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Roots pump drive end - horizontal direction") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lcb, lcb_i) in markeData.lcb_qd"
            :key="lcb_i"
            class="detail-cont"
          >
            <label>{{ lcb.label }}:</label>
            <div :style="{ color: statusColor[lcb.status].color }">
              {{ lcb.value }}
            </div>
            <div :style="{ color: statusColor[lcb.status].color }">
              <img
                :src="statusColor[lcb.status].icon"
                :class="[
                  lcb.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 罗茨泵非驱动端水平 -->
    <div
      id="marke-lcb-fqd"
      class="tire"
      v-if="markeData.lcb_fqd.length"
      style="top:0rem;left:0.1rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Roots pump non-drive end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lcb, lcb_i) in markeData.lcb_fqd"
            :key="lcb_i"
            class="detail-cont"
          >
            <label>{{ lcb.label }}:</label>
            <div :style="{ color: statusColor[lcb.status].color }">
              {{ lcb.value }}
            </div>
            <div :style="{ color: statusColor[lcb.status].color }">
              <img
                :src="statusColor[lcb.status].icon"
                :class="[
                  lcb.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -----------------------------  -->
    <!-- 螺杆泵电机非驱动端水平 -->
    <div
      id="marke-lgbdj-fqd"
      class="tire"
      v-if="markeData.lgbdj_fqd.length"
      style="top:0.7rem;left:-0.5rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Screw pump motor non-driven end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lgbdj, lgbdj_i) in markeData.lgbdj_fqd"
            :key="lgbdj_i"
            class="detail-cont"
          >
            <label>{{ lgbdj.label }}:</label>
            <div :style="{ color: statusColor[lgbdj.status].color }">
              {{ lgbdj.value }}
            </div>
            <div :style="{ color: statusColor[lgbdj.status].color }">
              <img
                :src="statusColor[lgbdj.status].icon"
                :class="[
                  lgbdj.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 螺杆泵电机驱动端水平 -->
    <div
      id="marke-lgbdj-qd"
      class="tire"
      v-if="markeData.lgbdj_qd.length"
      style="top:-0.1rem;left:-0.4rem"
    >
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Screw pump motor drive end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lgbdj, lgbdj_i) in markeData.lgbdj_qd"
            :key="lgbdj_i"
            class="detail-cont"
          >
            <label>{{ lgbdj.label }}:</label>
            <div :style="{ color: statusColor[lgbdj.status].color }">
              {{ lgbdj.value }}
            </div>
            <div :style="{ color: statusColor[lgbdj.status].color }">
              <img
                :src="statusColor[lgbdj.status].icon"
                :class="[
                  lgbdj.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 螺杆泵驱动端水平 -->
    <div
      id="marke-lgb-qd"
      class="tire"
      v-if="markeData.lgb_qd.length"
      style="top:0.7rem;left:-0.5rem"
    >
      <div class="tire-detail">
        <div class="detail-head">{{ $t("Screw pump drive end level") }}</div>
        <div class="detail-main">
          <div
            v-for="(lgb, lgb_i) in markeData.lgb_qd"
            :key="lgb_i"
            class="detail-cont"
          >
            <label>{{ lgb.label }}:</label>
            <div :style="{ color: statusColor[lgb.status].color }">
              {{ lgb.value }}
            </div>
            <div :style="{ color: statusColor[lgb.status].color }">
              <img
                :src="statusColor[lgb.status].icon"
                :class="[
                  lgb.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 螺杆泵非驱动端水平 -->
    <div id="marke-lgb-fqd" class="tire" v-if="markeData.lgb_fqd.length">
      <div class="tire-detail">
        <div class="detail-head">
          {{ $t("Screw pump non-driven end level") }}
        </div>
        <div class="detail-main">
          <div
            v-for="(lgb, lgb_i) in markeData.lgb_fqd"
            :key="lgb_i"
            class="detail-cont"
          >
            <label>{{ lgb.label }}:</label>
            <div :style="{ color: statusColor[lgb.status].color }">
              {{ lgb.value }}
            </div>
            <div :style="{ color: statusColor[lgb.status].color }">
              <img
                :src="statusColor[lgb.status].icon"
                :class="[
                  lgb.status == 'normal'
                    ? 'status-icon-normal'
                    : 'status-icon-up'
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      statusColor: {
        normal: {
          color: "#00e7ff",
          icon: require("@/assets/normal.svg")
        },
        warning: {
          color: "#ffd643",
          icon: require("@/assets/up.svg")
        },
        error: {
          color: "#ff706f",
          icon: require("@/assets/up-red.svg")
        }
      }
    };
  },
  props: {
    markeData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {},
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../assets/scss/common.scss");
.tire {
  position: absolute;
  width: 300px;
  padding: 10px;
  border-radius: 10px;
  z-index: 2;
}
.tire .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00e7ff;
  display: inline-block;
}
.tire-detail {
  position: absolute;
  left: 115px;
  top: -140px;
  min-width: 250px;
  background: url("../../../assets/工单框.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;

  .detail-head {
    padding: 5px 0 5px 10px;
    margin: 1.5px 1.5px 0;
    background: linear-gradient(90deg, #00618b 0%, #00aeb8 100%);
    border-top-left-radius: 15px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 600;
  }
  .detail-main {
    flex: 1;
    background: rgba(0, 174, 184, 0.2);
    border-bottom-right-radius: 24px;
    box-sizing: border-box;
    .detail-cont {
      display: flex;
      align-items: center;
      padding: 5px 0 5px 10px;
      label {
        flex: 3;
      }
      div {
        flex: 1;
      }
    }
  }
}
.tire-line-dot-detail {
  width: 135px;
  height: 2px;
  background: linear-gradient(90deg, #01e7ff 0%, #0165a6 100%);
  transform: matrix(-1, 0, 0, 1, 0, 0);
  opacity: 0.8;
  transform: rotate(-45deg);
  position: absolute;
  top: -35px;
  left: -2px;
  z-index: -1;
}

.status-icon-normal {
  width: 8px;
  height: 2px;
}
.status-icon-up {
  width: 10px;
  height: 14px;
}
</style>
